import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import Image from '../atoms/Image'

const RelatedProductsBlock = ({ block }) => {
  if (block.products.length <= 0) return null
  return (
    <SbEditable content={block}>
      <section className="double-teaser-block related-products-block">
        <div className="double-teaser-block-container">
          <div className="double-teaser-block-wrapper">
            <div className="double-teaser-block-header">
              <Headline
                headline={block.headline}
                subheadline={block.subheadline}
              />
            </div>
            <div className="double-teaser-block-row justify-content-start">
              {block.products.length > 0 &&
                block.products?.map((item, index) => (
                  <section key={index} className="layered-teaser-item">
                    <article>
                      <Link link={`/${item.full_slug}`}>
                        <div className="layered-teaser-item-wrapper">
                          <div className="layered-teaser-item-image">
                            <Image
                              className="img-fluid"
                              image={item.content.isolated_image}
                              alt={item.content.isolated_image_alt}
                              imageWidth="546"
                              imageHeight="405"
                              fillColor="ffffff"
                            />
                          </div>
                          <div className="layered-teaser-item-content">
                            <Headline
                              headline={item.name}
                              subheadline={item.content.headline}
                            />
                            {item.text?.length > 0 && (
                              <p className="layered-teaser-item-text">
                                {item.text}
                              </p>
                            )}
                            {item.link_text?.length > 0 && (
                              <span className="pseudo-link">
                                {item.link_text}{' '}
                                <i className="fas fa-angle-right"></i>
                              </span>
                            )}
                            {item.meta_info?.length > 0 && (
                              <div className="meta-info">{item.meta_info}</div>
                            )}
                          </div>
                        </div>
                      </Link>
                    </article>
                  </section>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default RelatedProductsBlock
